module.exports = __webpack_public_path__ + "static/media/xiconnnn.41f54b66.svg";